import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";

const AdsFaqCreate = () => {
    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");
    const [tag, setTag] = useState("");
    const [customTag, setCustomTag] = useState("");
    const [tagList, setTagList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [showCustomTagInput, setShowCustomTagInput] = useState(false);
    const navigate = useNavigate();

    const location = useLocation();
    const type = location.state?.type || {};  // 없을 수도 있으니 fallback 필요
    const storeBusinessNumber = location.state.storeBusinessNumber
    const faq = location.state?.faq || null;

    useEffect(() => {
        // 태그 목록 불러오기
        const fetchTags = async () => {
            try {
                const res = await axios.get(`${process.env.REACT_APP_FASTAPI_ADS_URL}/faq/tag`);
                const tags = (res.data || []).map(tag => tag.name); // 🔥 name만 추출
                setTagList(tags || []);
            } catch (err) {
                console.error("태그 불러오기 실패:", err);
            }
        };
        fetchTags();
    }, []);

    useEffect(() => {
        if (faq) {
            setTitle(faq.question);
            setContent(faq.answer);
            setTag(faq.category_name);  // 태그 이름 기준
        }
    }, [faq]);

    const handleTagChange = (e) => {
        const selected = e.target.value;
        if (selected === "__custom__") {
            setShowCustomTagInput(true);
            setTag("");  // 기존 선택 초기화
        } else {
            setTag(selected);
            setShowCustomTagInput(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const finalTag = showCustomTagInput ? customTag : tag;

        if (!title || !content || !finalTag) {
            setError("제목, 내용, 태그를 모두 입력해주세요.");
            return;
        }

        setLoading(true);

        try {
            if (faq) {
                const response = await axios.post(`${process.env.REACT_APP_FASTAPI_ADS_URL}/faq/update`, {
                    faq_id: faq.faq_id,
                    question: title,
                    answer: content,
                    name: finalTag,
                });

                if (response.status === 201) {
                    setError("FAQ 수정 성공.");
                }
            }
            else {
                const response = await axios.post(`${process.env.REACT_APP_FASTAPI_ADS_URL}/faq/create`, {
                    question: title,
                    answer: content,
                    name: finalTag,
                });

                if (response.status === 201) {
                    setError("FAQ 생성 성공.");
                }
            }

        } catch (error) {
            setError("FAQ 생성하는데 실패했습니다.");
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleGoToList = () => navigate("/ads/faq", { state: { storeBusinessNumber: storeBusinessNumber, type: type } });

    return (
        <div className="max-w-lg mx-auto p-6">
            <div className="flex justify-between items-center pb-4">
                <h2 className="text-2xl font-bold">
                    {faq ? "FAQ 수정" : "FAQ 작성"}
                </h2>
                <button onClick={handleGoToList} className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700">목록</button>
            </div>

            {error && <div className="text-red-600 pb-4">{error}</div>}

            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <label htmlFor="title" className="block text-sm font-medium text-gray-700">질문</label>
                    <input type="text" id="title" value={title} onChange={(e) => setTitle(e.target.value)} className="block w-full p-2 border rounded-lg" />
                </div>

                <div>
                    <label htmlFor="content" className="block text-sm font-medium text-gray-700">답변</label>
                    <textarea id="content" value={content} onChange={(e) => setContent(e.target.value)} rows="10" className="block w-full p-2 border rounded-lg" />
                </div>

                <div>
                    <label htmlFor="tag" className="block text-sm font-medium text-gray-700">카테고리</label>
                    <select id="tag" value={tag} onChange={handleTagChange} className="block w-full p-2 border rounded-lg">
                        <option value="">카테고리를 선택하세요</option>
                        {tagList.map((t) => (
                            <option key={t} value={t}>{t}</option>
                        ))}
                        <option value="__custom__">카테고리 추가하기</option>
                    </select>

                    {showCustomTagInput && (
                        <input
                            type="text"
                            placeholder="새 태그 입력"
                            value={customTag}
                            onChange={(e) => setCustomTag(e.target.value)}
                            className="mt-2 block w-full p-2 border rounded-lg"
                        />
                    )}
                </div>

                <button
                    type="submit"
                    disabled={loading}
                    className="w-full bg-blue-600 text-white p-2 rounded-lg hover:bg-blue-700 disabled:opacity-50"
                >
                    {loading ? "작성 중..." : "작성 완료"}
                </button>
            </form>
        </div>
    );
};

export default AdsFaqCreate;
